// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"na","tile":"nb","imageWrapper":"nc","img":"nd","header":"ne","caption":"nf"};